import { ScoreTimeSeriesRaw, ScoreTimeSeriesV2Raw } from '../../dto/scores/cube/raw/score-time-series.dto';
import { ScoreTimeSeriesResult } from '../../dto/scores/cube/mapped/score-time-series-results.dto';
import { IWorkingSessionsAnalyticsActivityEnum, IWorkingSessionsAnalyticsActivityEnumV2, IWorkingSessionsAnalyticsActivityScoresEnum, IWorkingSessionsAnalyticsActivityScoresEnumV2 } from '../../enum/working-sessions-analytics-activity.enum';

export const mapScoreTimeSeriesCube = (
    model: ScoreTimeSeriesRaw,
    scoreName: IWorkingSessionsAnalyticsActivityScoresEnum
  ): ScoreTimeSeriesResult => {
    return {
      date: 
        model[
          IWorkingSessionsAnalyticsActivityEnum.LocalSessionStart
        ],
      scoreValue: Number(
        model[
          scoreName
        ]
      ) || 0,
    };
}

export const mapScoreTimeSeriesCubeV2 = (
  model: ScoreTimeSeriesV2Raw,
  scoreName:  IWorkingSessionsAnalyticsActivityScoresEnumV2
): ScoreTimeSeriesResult => {
  return {
    date: 
      model[
        IWorkingSessionsAnalyticsActivityEnumV2.LocalSessionStart
      ],
    scoreValue: Number(
      model[
        scoreName
      ]
    ) || 0,
  };

}

  